import FooterNavbar from "../../../../footernavbar/FooterNavbar";

const OurLeadershipInside = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <div className="mt-2 py-5">
          <div className="w-70 container-fluid mx-auto mt-4">
            <div
              className="page-header min-vh-75 border-radius-2xl"
              style={{
                backgroundImage: "url('../../assets/img/footer/surajahmed.JPG')",
              }}
            >
              <div className="container mt-12 pt-12 ps-4">
                <h1 className="text-white text-normal">Suraj Ahmed</h1>
                <h5 className="text-white mb-0 text-normal">FOUNDER & CEO</h5>
              </div>
            </div>
          </div>
        </div>
        <div className="container bg-white py-0 w-70">
          <div className="row container justify-content-between mx-auto d-flex py-4">
            <div className="col-lg-6">
              <div>
                <p className="text-black fs-5 source-serif-4">
                  In the dynamic world of e-commerce, strong leadership is
                  crucial for navigating the challenges and opportunities that
                  arise. At the helm of Sworld Solutions Private Limited is
                  Suraj Ahamed D, a visionary leader whose diverse background
                  and robust educational foundation have equipped him to steer
                  his company towards success.
                </p>
              </div>
              <div>
                <p className="text-black fs-5 source-serif-4">
                  Suraj Ahamed D was born and brought up in Chittoor, Andhra
                  Pradesh. His journey in education began with a B.Tech in
                  Mechanical Engineering from TRR College of Engineering, under
                  Jawaharlal Nehru Technological University (JNTU), Hyderabad.
                  This technical foundation provided him with a strong
                  analytical and problem-solving skill set.
                </p>
                <p className="text-black fs-5 source-serif-4">
                  Understanding the evolving landscape of technology, Suraj
                  pursued a Masters in Computer Science & IT from Jain
                  University, Bangalore. This advanced degree expanded his
                  knowledge in critical areas such as software development, data
                  analytics, and information technology management, all of which
                  are essential for the e-commerce industry. Suraj further honed
                  his skills with specialized training in Project Management
                  Planning (PMP) from Amity Business School. This training has
                  been instrumental in his ability to plan, execute, and oversee
                  complex projects, ensuring that Sworld Solutions remains agile
                  and efficient in a competitive market.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mt-0">
                <p className="text-black fs-5 source-serif-4">
                  As the Founder and CEO of Sworld Solutions Private Limited,
                  Suraj Ahamed D brings a unique blend of technical expertise
                  and strategic vision. His leadership is characterized by a
                  commitment to innovation, customer-centric solutions, and
                  operational excellence. Suraj's hands-on approach and ability
                  to anticipate market trends have positioned Sworld Solutions
                  as a rising star in the e-commerce sector.
                </p>
              </div>
              <div className="mt-4">
                <p className="text-black fs-5 source-serif-4">
                  Suraj's vision for Sworld Solutions goes beyond mere market
                  success. He aims to build a company that not only meets the
                  demands of today's consumers but also sets new standards for
                  e-commerce innovation. By fostering a culture of continuous
                  learning and adaptation, Suraj ensures that Sworld Solutions
                  is always ready to embrace new technologies and methodologies.
                </p>
              </div>
              <div className="mt-4">
                <p className="text-black fs-5 source-serif-4">
                  Leadership in the e-commerce industry requires a delicate
                  balance of technical knowledge, strategic foresight, and the
                  ability to inspire and manage teams. Suraj Ahamed D embodies
                  these qualities, making him a formidable leader in the
                  e-commerce space. Under his guidance, Sworld Solutions Private
                  Limited is well on its way to achieving significant milestones
                  and redefining the e-commerce experience for its customers.
                </p>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OurLeadershipInside;
